// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"4784f39a","440":"f84cb838","551":"566789df","893":"76091239"}[chunkId] + ".chunk.js";
};